<template>
  <div class="user-wrapper">
    <div class="content-box">
<!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar()"/>
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item>
            <router-link to="/account/setting/base?type=base">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item>
            <a @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
// import NoticeIcon from '@/components/NoticeIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'UserMenu',
  components: {
    // NoticeIcon
  },
  methods: {
    ...mapGetters(['nickname', 'avatar']),
    async handleLogout () {
      await this.confirm('提示', '确定要退出登录吗？')
      this.$tkParse.setSessionToken(null)
      this.$store.commit('setUser', null)
      this.$store.commit('setSessionToken', null)
      this.$router.replace('/user/login')
    }
  }
}
</script>
